import { Restaurant } from "@/model/entities";
import { db } from "@/firebase";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  setDoc,
  where,
} from "firebase/firestore";

export const restaurantService = {
  fetchRestaurantById: async (id: string) => {
    const restaurantRef = doc(collection(db, "restaurants"), id);
    const restaurantSnap = await getDoc(restaurantRef);
    if (!restaurantSnap.exists()) {
      console.warn(`No restaurant found for id: ${id}`);
      return null;
    }
    const data = restaurantSnap.data();
    if (!data.categories) {
      console.warn(
        `Restaurant document for id ${id} is missing 'categories' field. Adding empty array.`
      );
      data.categories = [];
    }
    return { ...data, id } as Restaurant;
  },

  fetchRestaurantBySubdomain: async (subdomain: string) => {
    const restaurantsRef = collection(db, "restaurants");
    const q = query(restaurantsRef, where("subdomain", "==", subdomain));
    const snapshot = await getDocs(q);
    if (!snapshot.empty) {
      const doc = snapshot.docs[0];
      return { id: doc.id, ...doc.data() } as Restaurant;
    }
    return null;
  },

  subscribe: async (id: string, callback: (restaurant: Restaurant) => void) => {
    const restaurantRef = doc(collection(db, "restaurants"), id);
    const unsubscribe = onSnapshot(restaurantRef, (snapshot) => {
      const restaurant = snapshot.data() as Restaurant;
      callback(restaurant);
    });
    return unsubscribe;
  },

  update: async (id: string, data: Partial<Restaurant>): Promise<boolean> => {
    try {
      const restaurantRef = doc(collection(db, "restaurants"), id);
      await setDoc(restaurantRef, data, { merge: true });
      return true;
    } catch (error) {
      console.error("Error updating restaurant:", error);
      return false;
    }
  },

  delete: async (id: string): Promise<boolean> => {
    try {
      const restaurantRef = doc(collection(db, "restaurants"), id);
      await deleteDoc(restaurantRef);
      return true;
    } catch (error) {
      console.error("Error deleting restaurant:", error);
      return false;
    }
  },

  getSubdomain: () => {
    if (typeof window === "undefined") return undefined;
    const host = window.location.hostname;
    const parts = host.split(".");
    if (host.includes("localhost")) {
      if (parts.length > 1) return parts[0];
      return undefined;
    }
    if (parts.length > 2) return parts[0];
    return undefined;
  },
};
